export default __webpack_public_path__ + "static/media/caret.2ac91c84.svg";